<div class="encabezado">
  <!-- Header -->
  <div>
    <div>
      <div>
        <h5 class="titulo1">
          {{ "communication.voip.call_history" | translate }}
        </h5>
      </div>
    </div>
  </div>

  <!-- Search bar row -->
  <div class="row mb-3">
    <div class="col-8">
      <div class="calls-search-row">
        <div class="search-input-wrap">
          <i class="icon-magnifier"></i>
          <input type="text" class="form-control search-input"
            [(ngModel)]="searchText"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'communication.voip.search_calls' | translate">
          <button class="search-clear-btn" *ngIf="searchText" (click)="searchText = ''; onFilterChange()">
            <i class="icon-cross"></i>
          </button>
        </div>
        <select class="form-control filter-select" [(ngModel)]="filterDirection" (ngModelChange)="onFilterChange()">
          <option value="">{{ "communication.voip.all_directions" | translate }}</option>
          <option value="inbound">{{ "communication.voip.inbound" | translate }}</option>
          <option value="outbound">{{ "communication.voip.outbound" | translate }}</option>
        </select>
        <select class="form-control filter-select" [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()">
          <option value="">{{ "communication.voip.all_statuses" | translate }}</option>
          <option value="answered">{{ "communication.voip.status_answered" | translate }}</option>
          <option value="missed">{{ "communication.voip.status_missed" | translate }}</option>
          <option value="busy">{{ "communication.voip.status_busy" | translate }}</option>
          <option value="failed">{{ "communication.voip.status_failed" | translate }}</option>
        </select>
      </div>
    </div>
    <div class="col-4">
      <div class="btn-izq">
        <button class="btn d-flex align-items-center gap-2" type="button" (click)="toggleAgenda()">
          <i class="icon-contacts"></i>
          <span class="add-btn-text">{{ "communication.voip.contacts" | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Content: list + detail -->
  <div class="calls-split" [class.detail-open]="selectedCall">
    <div class="calls-list-panel">
      <div class="calls-list" *ngIf="!isLoading">
        <div class="call-item" *ngFor="let call of calls"
          [class.selected]="selectedCall?.reference === call.reference"
          (click)="selectCall(call)">

          <div class="call-direction">
            <i [class]="getDirectionIcon(call.direction)"
               [ngClass]="{'text-success': call.status === 'answered', 'text-danger': call.status === 'missed' || call.status === 'failed', 'text-warning': call.status === 'busy'}">
            </i>
          </div>

          <div class="call-info">
            <div class="call-top-row">
              <span class="call-contact">{{ getContactName(call) }}</span>
              <span class="call-date">{{ formatDate(call.started_at) }}</span>
            </div>
            <div class="call-phone">{{ getPhoneNumber(call) }}</div>
            <div class="call-bottom-row">
              <span class="badge" [ngClass]="getStatusClass(call.status)">
                {{ "communication.voip.status_" + call.status | translate }}
              </span>
              <span class="call-duration" *ngIf="call.talk_time && call.talk_time > 0">
                <i class="icon-clock"></i> {{ formatDuration(call.talk_time || 0) }}
              </span>
              <span class="call-disposition" *ngIf="call.disposition" [ngClass]="getDispositionClass(call.disposition)">
                {{ "communication.voip.disposition_" + call.disposition | translate }}
              </span>
            </div>
            <div class="call-meta" *ngIf="call.order || call.has_recording || call.tags.length > 0">
              <span class="badge text-campaign me-1" *ngIf="call.order">
                <i class="icon-clipboard-check"></i> {{ call.order.reference }}
              </span>
              <span class="badge text-draft me-1" *ngIf="call.has_recording">
                <i class="icon-mic"></i> {{ "communication.voip.recording" | translate }}
              </span>
              <span class="badge text-no-action me-1" *ngFor="let tag of call.tags">{{ tag }}</span>
            </div>
          </div>
        </div>

        <div class="empty-state" *ngIf="calls.length === 0">
          <i class="icon-phone"></i>
          <p>{{ "communication.voip.no_calls" | translate }}</p>
        </div>
      </div>

      <div class="loading-state" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <div class="calls-detail-panel" *ngIf="selectedCall">
      <app-call-detail
        [call]="selectedCall"
        (close)="closeDetail()">
      </app-call-detail>
    </div>
  </div>

  <!-- Slide Panel: Agenda -->
  <div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showAgenda }">
    <app-contacts-agenda
      *ngIf="showAgenda"
      (backButtonClick)="closeAgenda()"
      (callContact)="onCallFromAgenda($event)">
    </app-contacts-agenda>
  </div>
  <div class="overlay" *ngIf="showAgenda" (click)="closeAgenda()"></div>
</div>
